import React from 'react';
import RequiredMark from './RequiredMark';

const RequiredLegend = ({ className = '' }) => (
  <p className={`required-legend ${className}`.trim()}>
    <RequiredMark />
    <span>표시는 작성완료 시 필수 입력 항목입니다.</span>
  </p>
);

export default RequiredLegend;
